import Vue from 'vue'
import '@/plugins/vuemeta'
import '@/plugins/vuetimeago'
import '@/plugins/vuesocial'
import BaseConfig from "./config"
import ApiService from './api/api.service'

// Styles
import '@/sass/main.scss'


/*
* Creating base config
*/
Vue.use(BaseConfig, {
    store: new BaseConfig.Store({
        name: "Arclif"
    })
})




// API Init
ApiService.init()